import { Component } from '@angular/core';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

@Component({
  selector: 'app-kullanim-kosullari',
  standalone: true,
  imports: [NewsletterComponent],
  templateUrl: './kullanim-kosullari.component.html',
  styleUrl: './kullanim-kosullari.component.css'
})
export class KullanimKosullariComponent {

}
